<template>
  <Card :title="name">
    <div v-for="(d, i) in surgeryRecords" :key="i">
      <Divider> 记录{{ i + 1 }}</Divider>
      <Field
        v-model="d.position"
        label="手术部位"
        label-width="60%"
        :disabled="d.disabledPos"
        :readonly="readonly"
        placeholder="请输入"
      />
      <Field
        v-model="d.washHands"
        label="洗手护士次数"
        label-width="60%"
        :readonly="readonly"
        placeholder="请输入"
      />
      <Field
        v-model="d.itinerate"
        label="巡回护士次数"
        label-width="60%"
        :readonly="readonly"
        placeholder="请输入"
      />
      <Field
        v-model="d.sign"
        label="指导老师签名"
        label-width="60%"
        :readonly="readonly"
        placeholder="请输入"
      />
      <div class="action" v-if="!readonly">
        <VanBtn
          round
          @click="delRecord(i)"
          :disabled="surgeryRecords.length === 1"
          type="danger"
          color="#EA514B"
          size="small"
          >删除</VanBtn
        >
      </div>
    </div>
    <div class="action" v-if="!readonly">
      <VanBtn round type="primary" size="small" @click="addRecord()"
        >添加其它</VanBtn
      >
    </div>
  </Card>
</template>
<script>
import { Field, Button as VanBtn, Divider } from "vant";
import Card from "@/components/trainingManual/card/Card.vue";
export default {
  name: "SurgeryRecords",
  props: {
    title: String,
    readonly: Boolean
  },
  data: function() {
    return {
      name: "二、手术配合记录",
      surgeryRecords: [
        {
          position: "头颅手术",
          washHands: "",
          itinerate: "",
          sign: "",
          disabledPos: true
        },
        {
          position: "颈部、胸部手术",
          washHands: "",
          itinerate: "",
          sign: "",
          disabledPos: true
        },
        {
          position: "腹部手术",
          washHands: "",
          itinerate: "",
          sign: "",
          disabledPos: true
        },
        {
          position: "骨科手术",
          washHands: "",
          itinerate: "",
          sign: "",
          disabledPos: true
        },
        {
          position: "泌尿外科手术",
          washHands: "",
          itinerate: "",
          sign: "",
          disabledPos: true
        },
        {
          position: "妇科手术",
          washHands: "",
          itinerate: "",
          sign: "",
          disabledPos: true
        },
        {
          position: "产科手术",
          washHands: "",
          itinerate: "",
          sign: "",
          disabledPos: true
        },
        {
          position: "腔镜手术",
          washHands: "",
          itinerate: "",
          sign: "",
          disabledPos: true
        }
      ]
    };
  },
  methods: {
    addRecord() {
      this.surgeryRecords.push({
        position: "",
        washHands: "",
        itinerate: "",
        sign: "",
        disabledPos: false
      });
    },
    delRecord(index) {
      if (this.surgeryRecords.length === 1) {
        return;
      }
      this.surgeryRecords.splice(index, 1);
    }
  },
  components: { Card, Field, VanBtn, Divider }
};
</script>
<style lang="scss" scoped>
.action {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  button {
    width: 36%;
  }
}
</style>
